// extracted by mini-css-extract-plugin
module.exports = {"headline":"fader_headline__1KJTd","fadeIn":"fader_fadeIn__Cl8-S","fadeOut":"fader_fadeOut__1MVQd"};